import * as React from 'react';
import Skeleton from 'react-loading-skeleton';

export default function FooterSkeleton ( props ) {
  return (
    <div className="text-center">
      <Skeleton height={props?.height ? props.height : 250} className="col-12" />
    </div>
  )
}